
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AvailableLoan } from '@/interfaces/loan';
import CollectionAgencyContact from '@/components/Loans/Collections/CollectionAgencyContact.vue';
import applicationId from '@/filters/application-id';
import CustomButton from '~/components/Buttons/CustomButton.vue';

@Component({
  components: { CollectionAgencyContact, CustomButton }
})
export default class LoanInCollectionDialog extends Vue {
  @Prop({ type: Object, required: true }) readonly loan! : AvailableLoan;

  get humanLoanNumber(): string {
    return applicationId(this.loan.loan_number);
  }

  get hasCollectionAgencyInfo() : boolean {
    return this.loan.collection.collections_agency !== null;
  }
}
